<!-- components/TimezoneSwitcher.vue -->
<script setup lang="ts">
import { watch } from 'vue'
const { locale, setLocale } = useI18n()
const isOpen = ref(false)
const router = useRouter()
const timezoneCookie = useCookie('iqa-timezone')

const timezones = ref([
  'America/Ciudad_Juarez',
  'America/Guayaquil',
  'America/New_York',
  //'Europe/London',
  //'Europe/Madrid',
  'Europe/Warsaw',
  'Europe/Zurich',
  'Asia/Shanghai',
  'Asia/Tokyo',
  //'Australia/Sydney'
])

//Crea un alias para mantener pocas opciones visuales
const timezoneAliases: Record<string, string> = {
  // Ecuador
  'America/Bogota': 'America/Guayaquil',
  'America/Lima': 'America/Guayaquil',
  'America/Panama': 'America/Guayaquil',

  // Estados Unidos / Canadá (Eastern)
  'America/Detroit': 'America/New_York',
  'America/Toronto': 'America/New_York',
  'America/Montreal': 'America/New_York',
  'America/Nassau': 'America/New_York',
  'America/Indiana/Indianapolis': 'America/New_York',

  // Reino Unido
  'Europe/Belfast': 'Europe/London',
  'Europe/Guernsey': 'Europe/London',
  'Europe/Isle_of_Man': 'Europe/London',
  'Europe/Jersey': 'Europe/London',

  // España
  'Africa/Ceuta': 'Europe/Madrid',

  // Francia
  'Europe/Monaco': 'Europe/Paris',

  // Polonia
  'Europe/Prague': 'Europe/Warsaw',
  'Europe/Bratislava': 'Europe/Warsaw',
  'Europe/Budapest': 'Europe/Warsaw',

  // China
  'Asia/Chongqing': 'Asia/Shanghai',
  'Asia/Harbin': 'Asia/Shanghai',
  'Asia/Urumqi': 'Asia/Shanghai',

  // Australia
  'Australia/Melbourne': 'Australia/Sydney',
  'Australia/Canberra': 'Australia/Sydney',
  'Australia/NSW': 'Australia/Sydney'
}

// luego esto podría venir de user_preferences

const detected = Intl.DateTimeFormat().resolvedOptions().timeZone

const detectedTimezone =
  timezoneAliases[detected] ?? detected

const selectedTimezone = useState(
  'selected-timezone',
  () => timezones.value.includes(detectedTimezone)
    ? detectedTimezone
    : 'America/New_York'
)

  

if (timezoneCookie.value) {
  selectedTimezone.value = timezoneCookie.value
} else {
  timezoneCookie.value = selectedTimezone.value
}


const props = defineProps<{
  theme?: string,
  showOffset?: boolean
}>()

const { theme } = toRefs(props)

const buttonClass =
  'bg-3a-nav-btn' + (theme.value == 'dark' ? ' dark ' : '')


//timezones.value = Intl.supportedValuesOf('timeZone')

function switchTimezone(timezone: string) {

  selectedTimezone.value =  timezoneAliases[timezone] ?? timezone

    timezoneCookie.value = selectedTimezone.value

  // TODO:
  // await updateUserPreferences({
  //   timezone
  // })

  isOpen.value = false
  swal_loading();
  router.go(0);
}
function getTimezoneLabel(timezone: string) {
  if (!props.showOffset)
    return timezone

  const formatter = new Intl.DateTimeFormat('en', {
    timeZone: timezone,
    timeZoneName: 'longOffset'
  })

  const parts = formatter.formatToParts(new Date())

  const offset = parts.find(
    p => p.type === 'timeZoneName'
  )?.value ?? ''

  return `(${offset}) ${timezone}`
}
</script>

<template>
  <div class="relative inline-block text-left">
    <button
      @click="isOpen = !isOpen"
      :class="buttonClass + ' inline-flex items-center justify-center gap-2 px-3 py-2 rounded hover:bg-white/50 dark:hover:bg-white/50 hover:text-black transition'"
    >
      <span>🌐</span>

      <span class="max-w-[260px] truncate">
        {{ props.showOffset ? getTimezoneLabel(selectedTimezone) : selectedTimezone.split('/').pop()  }}
      </span>

      <svg
        class="w-4 h-4 ml-1"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M19 9l-7 7-7-7"
        />
      </svg>
    </button>

    <div
      v-if="isOpen"
      :class="(props.showOffset ? ' left-0 ':' right-[-6px] ')+ 'absolute bottom-full mb-2 w-69 bg-white border border-gray-200 rounded shadow-lg z-50 text-black'"
    >
      <ul class="max-h-80 overflow-y-auto">
        <li
          v-for="timezone in timezones"
          :key="timezone"
        >
          <button
            @click="switchTimezone(timezone)"
            class="w-full text-left px-3 py-2 hover:bg-gray-100 transition cursor-pointer"
          >
            🌐 {{ getTimezoneLabel(timezone) }}
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>